<template>
  <v-layout row wrap align-center>
    <v-flex xs12>
      <v-card elevation="1">
        <div>
          <v-tabs centered v-model="active" slider-color="primary" color="Navy">
            <v-tab>Inbox</v-tab>
            <v-tab-item>
              <Admin-Inbox v-on:changeApp="changeApp" ref="inbox"></Admin-Inbox>
            </v-tab-item>
            <v-tab>Service Compliance</v-tab>
            <v-tab-item>
              <Admin-Scheduler></Admin-Scheduler>
            </v-tab-item>
            <v-tab>Facility Information</v-tab>
            <v-tab-item>
              <Admin-Facility></Admin-Facility>
            </v-tab-item>
            <v-tab>Users</v-tab>
            <v-tab-item>
              <Change-Roles></Change-Roles>
            </v-tab-item>
            <v-tab>Site Facilitators</v-tab>
            <v-tab-item>
              <Site-Facilitator></Site-Facilitator>
            </v-tab-item>
            <v-tab>Application Actions</v-tab>
            <v-tab-item>
              <review-app :id="id" v-on:refresh="refreshInbox"></review-app>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import appConfig from '@src/app.config'
import AdminInbox from '../../components/Admin/AdminInbox.vue'
import AdminScheduler from '../../components/Admin/AppScheduler.vue'
import AdminFacility from '../../components/Admin/FacilityInfo.vue'
import ChangeRoles from '../../components/Admin/UserManagement.vue'
import SiteFacilitatorsVue from '../../components/Admin/SiteFacilitators.vue'
import ReviewAppsVue from '../../components/Admin/ReviewApps.vue'

export default {
  page: {
    title: 'Admin',
  },
  name: 'AdminPage',
  components: {
    'Admin-Inbox': AdminInbox,
    'Admin-Scheduler': AdminScheduler,
    'Admin-Facility': AdminFacility,
    'Change-Roles': ChangeRoles,
    'Site-Facilitator': SiteFacilitatorsVue,
    'review-app': ReviewAppsVue,
  },
  data() {
    return {
      active: 0,
      id: 0,
    }
  },
  methods: {
    changeApp(val) {
      //debugger
      this.id = val
      this.active = 5
    },
    refreshInbox() {
      this.$refs.inbox.getInitialData()
      this.$refs.inbox.filterItems()
    },
  },
}
</script>
<style></style>
